<!-- 文章发布首页 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left: 30%">敏感词管理</span>
          </template>
        </Head>
      </el-col>
    </el-row>

    <el-row class="zw_nav">
      <el-col>
        <div class="grid-content bg-purple-dark nav-box">
          <ul class="nav clearfix">
            <li :class="{ active: isActive == '0' }" @click="show('0', '#1A80FC')" style="">
              敏感词拦截
            </li>
            <li :class="{ active: isActive == '1' }" @click="show('1', '#79E46E')">
              新增敏感词
            </li>
            <li :class="{ active: isActive == '2' }" @click="show('2', '#79E46E')">
              敏感词词库
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>

    <el-row v-show="isActive == 0" class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <Blocklist v-if="isShow"></Blocklist>
      </el-col>
    </el-row>

    <el-row v-show="isActive == 1" class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <Newsensitivity v-if="isShow"></Newsensitivity>
      </el-col>
    </el-row>

    <el-row v-show="isActive == 2" class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <ThesaurusList v-if="isShow" ref="ThesaurusClick"></ThesaurusList>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Head from "@/components/header/head.vue";
import ThesaurusList from "@/views/sensitiveWord/component/ThesaurusList";
import Blocklist from "@/views/sensitiveWord/component/Blocklist";
import Newsensitivity from "@/views/sensitiveWord/component/Newsensitivity";
import login from "@/views/login/login";
// import grbdXq from '@/views/article/';
export default {
  name: "sensitiveWord",
  data() {
    return {
      isShow: true,
      isActive: "0",
      status: "",
      itemData: {},
    };
  },
  methods: {
    show(index, color) {
      this.isActive = index;
      if (index == 2) {
        this.$refs.ThesaurusClick.getAricleFn(1, 10, '')
      }
    },
  },
  components: {
    ThesaurusList,// 敏感词库
    Blocklist,
    Head,
    Newsensitivity,
  },
};
</script>
<style lang="less" scoped>
.zw_nav {
  // height:110px;
  //padding: 0 22px;

  .nav-box {
    // background-color:yellow;
    background-color: #ffffff;
    height: 70px;
    //margin-top: 15px;
    //margin-bottom: 15px;
  }

  .nav {
    padding: 0px 0 0 315px;

    > li {
      line-height: 46px;
      width: 128px;
      //height: 46px;
      background: #eef2fb;
      box-shadow: 0px 0px 32px 6px rgba(141, 141, 141, 0.11);
      border-radius: 8px;
      float: left;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      color: #868ea7;
      margin-right: 50px;
    }

    li.active {
      background: #ffffff;
      color: #1a80fc;
    }
  }
}
</style>



